export default [
  {
    path: '/qualification_types',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'admin-qualificationTypes-list' */ '@/views/qualification_types/List')
  },
  {
    path: '/qualification_types/new',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'admin-qualificationTypes-create' */ '@/views/qualification_types/Create')
  },
  {
    path: '/qualification_types/:id',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'admin-qualificationTypes-show' */ '@/views/qualification_types/QualificationType')
  }
]
